import { render, staticRenderFns } from "./CNoStation.vue?vue&type=template&id=85c5a00a&"
import script from "./CNoStation.vue?vue&type=script&lang=js&"
export * from "./CNoStation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports